<template>
  <SectionContentLayout
    :state="state"
    content_class="contacts-group"
    invalid_text='contacts.group.invalid'
    invalid_icon='fas fa-users'
    error_text="contacts.list.error"
  >
      <template #close>
        <ActionButton
            @click="onClose()"
            class="close"
            icon="fas fa-times-circle"
            v-tooltip='"global.actions.close"'
        />
      </template>

      <template #header>
          <ContentTitle
            title="contacts.group_title"
          />
      </template>

      <template #actions_success v-if="contacts_selection.count === 0">
          <ActionButton
              v-if="recipients_group.emails_selected.count"
              v-tooltip='"contacts.actions.send_mail"'
              @click="onActionToSendMailAll()"
              icon='fas fa-pencil-alt'
          />
          <RouterButton
              :link="'/contacts/group/edit/' + group.id"
              v-tooltip='"contacts.actions.edit_group"'
              icon='fas fa-user-edit group-edit'
          />

        <ActionButton
            icon="fas fa-user-plus group-plus"
            v-tooltip="'contacts.actions.add_persons_to_group'"
            @click="onAddPersonsToGroupOpen()"
          />

          <ActionButton
              @click="onGroupDelete(group)"
              v-tooltip='"contacts.actions.delete_group"'
              icon='fas fa-trash-alt'
          />
      </template>

      <template #actions_over_success v-else>
          <ActionButton
              v-if="contacts_selection.emails_selected.count"
              @click="onActionToSendMail()"
              v-tooltip='"contacts.actions.send_mail"'
              icon='fas fa-pencil-alt'
          />

          <ActionButton
              @click="onPersonsRemove(group)"
              v-tooltip='"contacts.actions.remove_from_group"'
              icon='fas fa-user-minus'
              disabled=''
          />
      </template>

      <template #content_success>
          <div class="contact" v-if="group.id">
              <p class="group-name">
                  <small>{{Language.say('contacts.form.name')}}</small>
                  <span>{{group.name}}</span>
              </p>
          </div>

          <ContentSaving v-if="contacts_controller.state.events['group_remove_persons'] === 'loading'"
            text='contacts.form.saving'
            icon='fas fa-users'
          />

          <div class="form top-space" v-if="group.members_count">
              <p>{{Language.say('contacts.group.members')}}</p>
              <div class="group-contact" v-for="person in group.members" :key="person.id">
                  <div class="control-group">
                      <div class="control check-group">
                          <input type="checkbox" :id="'gpm_' + person.id" :checked="contacts_selection.index[person.id]">
                          <label :id="'gpm_' + person.id" @click="onPersonSelect(person)">
                              <span>{{person.name}}</span>
                              <small role="button">{{person.email}}</small>
                          </label>
                      </div>
                  </div>
              </div>
          </div>

          <div class="top-space" v-else>
              <p>{{Language.say('contacts.group.empty')}}</p>
              <ActionButton
                  icon="fas fa-user-plus group-plus"
                  text="contacts.actions.add_persons_to_group"
                  @click="onAddPersonsToGroupOpen()"
                />
          </div>
      </template>
  </SectionContentLayout>
</template>

<script setup>
  import {ref, reactive}                           from 'vue';
  import {onBeforeMount, onUnmounted, defineProps} from 'vue';
  import {useRoute, useRouter}                     from 'vue-router';
  import ContentTitle                              from '@/vue/Elements/Content/ContentTitle.vue';
  import ContentEmpty                              from '@/vue/Elements/Content/ContentEmpty.vue';
  import ContentSaving                             from '@/vue/Elements/Content/ContentSaving.vue';
  import ActionButton                              from '@/vue/Elements/Buttons/ActionButton.vue';
  import RouterButton                              from '@/vue/Elements/Buttons/RouterButton.vue';
  import SectionContentLayout                      from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language                                  from '@/js/Shared/Language/Language.js';
  import ContactsController                        from '@/js/Contacts/ContactsController';
  import ContactsSelectionCollection               from '@/js/Contacts/Collections/ContactsSelectionCollection';

  const props = defineProps({
    contacts_view: {
      required:true,
    }
  })

  const router              = useRouter();
  const route               = useRoute();
  const group               = ref();
  const state               = ref('loading');
  const recipients_group    = new ContactsSelectionCollection;
  const contacts_controller = ContactsController;
  const contacts_selection  = reactive(new ContactsSelectionCollection());

  onBeforeMount(async () => {
    contacts_controller.state.on('fetch_foreground', 'success', onLoad);
  });

  onUnmounted(async () => {
    contacts_controller.state.destroy('fetch_foreground', 'success', onLoad);
  });

  const onLoad = () => {
    setGroup();
    setState();
    setRecipients();
  }

  const onClose = () => {
    close();
  }

  const onAddPersonsToGroupOpen = () => {
    props.contacts_view.openContactsToGroup(group.value);
  }

  const onPersonSelect = (person) => {
    contacts_selection.toggle(person.id, person);
  }

  const onPersonsRemove = async () => {
    if (await contacts_controller.removePersonsFromGroup(group.value, contacts_selection.getIndexKeys()) === false) {
      return;
    }

    contacts_selection.reset();
  }

  const setGroup = () => {
    group.value = contacts_controller.contacts.groups.get(route.params.contact_id);
  }

  const setState = () => {
    state.value = (!group.value.id) ? 'invalid' : contacts_controller.state.events['fetch_foreground'];
  }

  const close = () => {
    router.push('/contacts');
  }

  const onGroupDelete = (group) => {
    let contacts = new ContactsSelectionCollection();
    contacts.add(group);
    props.contacts_view.openContactsDelete(contacts);
  }

  const setRecipients = () => {
    recipients_group.addItems(group.value.members);
  }

  const onActionToSendMailAll = () => {
    props.contacts_view.onActionToSendMail(recipients_group.items);
  }

  const onActionToSendMail = () => {
    props.contacts_view.onActionToSendMail(
      contacts_selection.getRecipients()
    );
  }
</script>
